// O consentimento do Google abre numa aba nova, e a tela do Atende fica onde estava. A aba nasce
// no clique, porque o bloqueador de pop-up recusa uma aba aberta depois de esperar o servidor, e
// só recebe o endereço quando ele chega. Sem aba (pop-up bloqueado), segue na mesma aba, como antes.
export const openGoogleConsent = async requestUrl => {
  const tab = window.open('', '_blank');
  try {
    const url = await requestUrl();
    if (tab) tab.location.assign(url);
    else window.location.assign(url);
  } catch (error) {
    tab?.close();
    throw error;
  }
};
